<template>
  <div class="entry">
    <div v-for="item in list" class="item" @click="jump(item.url)">
      <div class="angle" style="cursor: pointer">
        <div class="angleSon" style="cursor: pointer">
          <div
            class="buPartTitle"
            style="
              font-weight: 400;
              font-size: 1vw;
              color: #bf9d63;
              padding-top: 1vw;
              padding-bottom: 1vw;
            "
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useDataStore } from "@/store";
import { mapActions } from "pinia";
export default {
  name: "page3",
  components: {
    // ring,
  },
  created() {
    this.setTitle("数据查询下载平台");
    this.setLeftTop(false);
  },
  data() {
    return {
      list: [
        {
          name: "万安 投资计划项目明细",
          url: "https://bw4-app-p01.gmfintl.com:44300/sap/bc/webdynpro/sap/fpm_bics_ovp?bsa_query=ZAAMCP010_Q001&sap-client=800&sap-language=ZH#",
        },
        {
          name: "万安 法律诉讼_明细",
          url: "https://bw4-app-p01.gmfintl.com:44300/sap/bc/webdynpro/sap/fpm_bics_ovp?bsa_query=ZALGCP001_Q004&sap-client=800&sap-language=ZH#",
        },
        {
          name: "万安 长期应收账款/超信贷额度（客户明细）",
          url: "https://bw4-app-p01.gmfintl.com:44300/sap/bc/webdynpro/sap/fpm_bics_ovp?bsa_query=ZAARCP002_Q003&sap-client=800&sap-language=ZH#",
        },
        {
          name: "万安 存货周转率",
          url: "https://bw4-app-p01.gmfintl.com:44300/sap/bc/webdynpro/sap/fpm_bics_ovp?bsa_query=ZAIMCP004_Q001&sap-client=800&sap-language=ZH#",
        },
        {
          name: "万安 大额支付明细",
          url: "https://bw4-app-p01.gmfintl.com:44300/sap/bc/webdynpro/sap/fpm_bics_ovp?bsa_query=ZALJCP002_Q011&sap-client=800&sap-language=ZH#",
        },
        {
          name: "万安 固定资产处置明细",
          url: "https://bw4-app-p01.gmfintl.com:44300/sap/bc/webdynpro/sap/fpm_bics_ovp?bsa_query=ZALJCP002_Q012&sap-client=800&sap-language=ZH#",
        },
        {
          name: "万安 人力资源明细",
          url: "https://bw4-app-p01.gmfintl.com:44300/sap/bc/webdynpro/sap/fpm_bics_ovp?bsa_query=ZAAMCP005_Q001&sap-client=800&sap-language=ZH#",
        },
        {
          name: "万安 采购详情",
          url: "https://bw4-app-p01.gmfintl.com:44300/sap/bc/webdynpro/sap/fpm_bics_ovp?bsa_query=ZARMCP003_Q001&sap-client=800&sap-language=ZH#",
        },
        {
          name: "SALOV 投资计划项目明细",
          url: "https://bw4-app-p01.gmfintl.com:44300/sap/bc/webdynpro/sap/fpm_bics_ovp?bsa_query=ZAAMCP010_Q002&sap-client=800&sap-language=ZH#",
        },
        {
          name: "SALOV 法律诉讼_明细",
          url: "https://bw4-app-p01.gmfintl.com:44300/sap/bc/webdynpro/sap/fpm_bics_ovp?bsa_query=ZALGCP002_Q004&sap-client=800&sap-language=ZH#",
        },
        {
          name: "SALOV - 人力资源明细",
          url: "https://bw4-app-p01.gmfintl.com:44300/sap/bc/webdynpro/sap/fpm_bics_ovp?bsa_query=ZAHRCP002_Q003&sap-client=800&sap-language=ZH#",
        },
        {
          name: "光明亚太 CAPEX投资明细",
          url: "https://bw4-app-p01.gmfintl.com:44300/sap/bc/webdynpro/sap/fpm_bics_ovp?bsa_query=ZABFA001_Q008&sap-client=800&sap-language=ZH#",
        },
        {
          name: "光明亚太 员工伤害信息明细",
          url: "https://bw4-app-p01.gmfintl.com:44300/sap/bc/webdynpro/sap/fpm_bics_ovp?bsa_query=ZCBFAD017_Q001&sap-client=800&sap-language=ZH#",
        },
        {
          name: "光明亚太 P1级别网络安全事故发生明细",
          url: "https://bw4-app-p01.gmfintl.com:44300/sap/bc/webdynpro/sap/fpm_bics_ovp?bsa_query=ZABFA001_Q020&sap-client=800&sap-language=ZH#",
        },
        {
          name: "梅林 预付账款供应商明细",
          url: "https://bw4-app-p01.gmfintl.com:44300/sap/bc/webdynpro/sap/fpm_bics_ovp?bsa_query=ZAGMMLCP001_Q005&sap-client=800&sap-language=ZH#",
        },
        {
          name: "梅林 异常出入库金额（明细）",
          url: "https://bw4-app-p01.gmfintl.com:44300/sap/bc/webdynpro/sap/fpm_bics_ovp?bsa_query=ZAGMMLCP002_Q005&sap-client=800&sap-language=ZH#",
        },
        {
          name: "梅林 原材料疑似异常采购（明细）",
          url: "https://bw4-app-p01.gmfintl.com:44300/sap/bc/webdynpro/sap/fpm_bics_ovp?bsa_query=ZAGMMLCP004_Q002&sap-client=800&sap-language=ZH#",
        },
      ],
    };
  },
  methods: {
    ...mapActions(useDataStore, ["setTitle", "setLeftTop", "setBackurl"]),
    jump(page) {
      if (page) {
        window.open(page, "_blank");
      } else {
        this.$message.info("暂无跳转链接");
      }
    },
  },
  mounted() {},
  beforeDestroy() {},
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/index.less";
.entry {
  position: relative;
  z-index: 1;
  padding-top: 2vw;
  padding-left: 2vw;
  padding-right: 2vw;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .item {
    cursor: pointer;
    width: 22vw;
    margin-bottom: 2vw;
    margin-right: 2.5vw;
    text-align: center;
    /* 选择所有索引号是4的倍数的元素，并去除其右侧边距 */
    &:nth-child(4n) {
      margin-right: 0;
    }
  }
  .changeRateWrap {
  }
}
</style>
